import { render, staticRenderFns } from "./ClientPayment.vue?vue&type=template&id=41d2b1f8"
import script from "./ClientPayment.vue?vue&type=script&lang=js"
export * from "./ClientPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports